import Glide from '@glidejs/glide';

const config = {
    type: 'carousel',
    startAt: 0,
    perView: 1,
    autoplay: 3500,
    hoverpause: false,
    keyboard: false,
    swipeThreshold: false,
    dragThreshold: false,
    gap: 0,
};

let sliders = document.querySelectorAll('.glide');
for (let i = 0; i < sliders.length; i++) {
    new Glide(sliders[i], config).mount();
}
